import { ExperienceName } from '@atlassian/conversation-assistant-instrumentation/constants/experience-tracker';
import { StoreActionLoggableName } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { createSafeAction, type SafeAction } from './createSafeAction';
import { type ReconnectToInProgressStreamParams } from './reconnect-action';
import { reconnectToInProgressStreamProvider } from './reconnectToInProgressStreamProvider';
import { setConversationData } from './setConversationData';
import type { ChatStoreAction } from './types';

/**
 * Reconnects to an in-progress message stream when loading a conversation
 * where the last message has async_status 'IN_PROGRESS'
 */
export const reconnectToInProgressStream: SafeAction<[ReconnectToInProgressStreamParams]> =
	createSafeAction(
		StoreActionLoggableName.reconnectToInProgressStream,
		({
			conversationId,
			messageId,
			lastEventId,
			isDeepResearch,
			abortCurrentRequest,
			answerIndex,
			onComplete,
		}: ReconnectToInProgressStreamParams): ChatStoreAction =>
			reconnectToInProgressStreamProvider({
				conversationId,
				messageId,
				lastEventId,
				isDeepResearch,
				abortCurrentRequest,
				answerIndex,
				onComplete,
				setConversationData,
			}),
		{
			experienceName: () => ExperienceName.RECONNECT_TO_ACTIVE_STREAM,
		},
	);
